import React from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

interface CustomInputTextProps {
  value: string;
  setValue: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  icon: React.ReactNode;
  iconPosition?: string;
  invalid?: boolean;
  disabled?: boolean;
}

const CustomInputText: React.FC<CustomInputTextProps> = ({
  value,
  setValue,
  onBlur,
  placeholder,
  icon,
  iconPosition,
  invalid,
  disabled,
}) => {
  const position = iconPosition as "left" | "right";

  return (
    <IconField iconPosition={position || "left"}>
      <InputIcon>{icon}</InputIcon>
      <InputText
        className="w-full"
        type="text"
        placeholder={placeholder || ""}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setValue(e.target.value)
        }
        onBlur={onBlur}
        invalid={invalid}
        disabled={disabled}
      />
    </IconField>
  );
};

export default CustomInputText;
